export const authBaseDomain = 'https://back-end-preprod.nispand.com'

export const stage = '/v2'

export const loginAPI = '/auth/authdoor' // POST

export const loginOtpAPI = '/auth/verify-otp' // POST

export default `${authBaseDomain}${stage}`